import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=48d0c1e6&scoped=true&"
import script from "./Wrapper.vue?vue&type=script&lang=js&"
export * from "./Wrapper.vue?vue&type=script&lang=js&"
import style0 from "./Wrapper.vue?vue&type=style&index=0&id=48d0c1e6&scoped=true&lang=scss&"
import style1 from "./Wrapper.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d0c1e6",
  null
  
)

export default component.exports